<!-- pages/ExpertSignup.vue -->
<template>
  <div class="min-h-screen w-screen bg-white">
    <div class="flex flex-col md:flex-row w-full h-screen">
      <RouterView />

      <div class="hidden md:flex flex-1 h-screen relative w-full md:w-2/3">
        <AmbientFabricBackground :settings="{ class: 'w-full h-full' }">
          <div class="flex items-center justify-center h-full px-6">
            <div class="relative w-[720px] max-w-full">
              <img :src="mainImage" alt="Main Expert" class="w-full shadow-2xl" />
              <img :src="topLeftImage" alt="Top Left" class="w-50 h-50 object-cover absolute -top-20 -left-20" />
              <img :src="bottomRightImage" alt="Bottom Right" class="w-50 h-50 absolute -bottom-20 -right-20" />
            </div>
          </div>
        </AmbientFabricBackground>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AmbientFabricBackground } from '@shopexperts/shared';

const mainImage = new URL('../../assets/icons/centeredImage.png', import.meta.url).href
const topLeftImage = new URL('../../assets/icons/leftImage.png', import.meta.url).href
const bottomRightImage = new URL('../../assets/icons/rightImage.png', import.meta.url).href
</script>
